module.exports = __webpack_public_path__ + "img/Poultrac_logo.92716912.png";